export default __webpack_public_path__ + "media/images/work_with_us/team-pic-1-633a94ddd21f5da006e7084dfb3b8635.png";